import { AppRoutes } from './app.routes';
import { AuthRoutes } from './auth.routes';
import { SyncProgressModal } from '@/components/waha/SyncProgressModal';
import { useAuthQuery } from '@/hooks/Auth';
import { useSyncProgress } from '@/hooks/common/useSyncProgress';

export const Router = () => {
  const { isAuthenticated, isLoading, authChecked } = useAuthQuery();
  const { isOpen, progress } = useSyncProgress();

  // Show loading state while checking authentication
  if (!authChecked || isLoading) {
    return null;
  }

  // Route based on authentication status
  return (
    <>
      {isAuthenticated ? <AppRoutes /> : <AuthRoutes />}

      {/* Global sync progress modal - shows when syncing workspace data */}
      {isAuthenticated && (
        <SyncProgressModal isOpen={isOpen} progress={progress} />
      )}
    </>
  );
};
